(function () {
  function init() {
    var section = document.getElementById('about-storytelling');
    if (!section) return;

    // The horizontally-scrolling track is a separate element from the
    // section itself so the fixed-position nav (a sibling) never gets
    // clipped by the track's overflow: hidden on mobile.
    var track = document.getElementById('about-storytelling-track') || section;

    var slides = Array.prototype.slice.call(section.querySelectorAll('.about-slide'));
    var nav = section.querySelector('[data-storytelling-nav]');
    var dots = Array.prototype.slice.call(section.querySelectorAll('.about-slide-nav__dot'));

    if (!slides.length || !dots.length) return;

    // Mobile is a horizontal swipe slider (see about-us.liquid); desktop is
    // the vertical sticky-cover layout. Dot behavior differs per axis.
    var mql = window.matchMedia('(max-width: 749px)');

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById('about-slide-' + dot.dataset.slideNav);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
        }
      });
    });

    // With position: sticky, an earlier slide never actually leaves the
    // viewport geometrically once it starts sticking — it's just visually
    // covered by the next one. IntersectionObserver's isIntersecting can't
    // tell "covered" from "on top", so relying on it only reliably updates
    // scrolling downward. Instead, on every scroll we work out which slide
    // is currently the topmost one (the last slide whose top has reached
    // the middle of the viewport) — this is correct in both directions.
    // On mobile the section itself scrolls horizontally, so we instead find
    // whichever slide's center is closest to the container's center.
    var ticking = false;

    function updateActiveDot() {
      ticking = false;
      var activeIndex = 0;

      if (mql.matches) {
        var containerCenter = track.scrollLeft + track.clientWidth / 2;
        var closestDistance = Infinity;
        slides.forEach(function (slide, i) {
          var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          var distance = Math.abs(slideCenter - containerCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = i;
          }
        });
      } else {
        var viewportMid = window.innerHeight * 0.5;
        slides.forEach(function (slide, i) {
          var rect = slide.getBoundingClientRect();
          if (rect.top <= viewportMid) {
            activeIndex = i;
          }
        });
      }

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
      });
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActiveDot);
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    section.addEventListener('scroll', requestUpdate, { passive: true });
    updateActiveDot();

    if (!('IntersectionObserver' in window)) {
      if (nav) nav.classList.add('is-visible');
      return;
    }

    var sectionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (nav) nav.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );
    sectionObserver.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
